<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import { getBrowser } from '@/utils/index';

  export default {
    name: 'App',
    methods: {
      // 浏览器适配
      uselessBrowserTips() {
        //** 浏览器以及版本控制
        //** chrome(内核75)、edge、360(内核78)、360极速(内核78)
        const browser = getBrowser();

        let newTips =
            '我们推荐使用Chrome浏览器，其他可用浏览器：edge、safari、Firefox、360极速',
          newTitle = '当前浏览器暂不支持使用',
          newDown = '下载新版Chrome';

        if (
          !browser.chrome &&
          !browser.edge &&
          !browser.safari &&
          !browser.firefox &&
          !browser.weixin
        ) {
          this.$confirm(newTips, newTitle, {
            confirmButtonText: newDown,
            showCancelButton: false,
            closeOnClickModal: true, //是否可通过点击遮罩关闭
            closeOnPressEscape: false, //是否可通过按下 ESC 键关闭
            showClose: false, //是否显示右上角关闭按钮
            center: true,
            closeOnHashChange: false,
            beforeClose: function(action) {
              if (action === 'confirm') {
                let href = 'https://www.google.cn/chrome/index.html';
                window.open(href, '_blank');
              }
            }
          });
        }
      }
    },
    mounted() {
      this.uselessBrowserTips();
    }
  };
</script>
<style lang="scss"></style>
